<template>
  <div class="vux-tabpanel" draggable="true" :title="config.desc || config.text">
    <vux-tabpanel-item-component v-for="(c, i) in children" :key="c.key" :endpoint="endpoint" :group="group" :config="c" ref="childComponents" v-show="index === i"></vux-tabpanel-item-component>
    <div data-position="in" :data-pc-key="config.key" class="vux-tabbar">
      <div v-for="(c, i) in children" :key="c.key" :class="index === i ? 'active' : ''" @click="index = i"></div>
    </div>
    <div class="vux-tabpanel-remove" @click="removeChild">删除</div>
  </div>
</template>

<script>
import mixin from './mixin.js'
import { getConfigApi } from '../util.js'
import VuxTabpanelItemComponent from './VuxTabpanelItemComponent'

export default {
  name: 'vux-tabpanel-component',
  components: {
    VuxTabpanelItemComponent
  },
  mixins: [mixin],
  data () {
    return {
      index: 0,
      properties: {
        index: 0
      }
    }
  },
  created () {
    if (!this.getChildren().length) {
      let items = []
      for (let i = 0; i < 4; i++) {
        items.push(getConfigApi(this.endpoint, this.group, 'TabpanelItem'))
      }
      this.setChildren(items)
    }
  },
  methods: {
    addChild (config) {
      if (config.name === 'TabpanelItem') {
        this.getChildren().push(config)
      } else {
        this.getChildComponents()[this.index].addChild(config)
      }
    },
    removeChild () {
      this.$store.commit('confirm', {
        title: '提示',
        msg: `您确认要删除第${this.index + 1}个页面吗?`,
        scope: this,
        callback: function () {
          let items = this.getChildren()
          items.splice(this.index, 1)

          this.index = this.index === items.length ? items.length - 1 : this.index

          if (this.index === -1) {
            this.$emit('remove', this)
          }
        }
      })
    }
  }
}
</script>

<style>
.vux-tabpanel{background:#999;}
.vux-tabpanel-remove{position:absolute;top:0;right:-52px;background:red;color:#fff;padding:2px 12px;cursor:pointer;}
.vux-tabbar{display:flex;}
.vux-tabbar>div{flex:1;text-align:center;min-height:50px;color:#fff;box-shadow:0px 0px 1px #FFF inset;cursor:pointer;}
.vux-tabbar>div.active{background:#409EFF;color:#fff;}
</style>
